<template>
  <div class>
    <!-- 상단 고정 캠페인 배너 -->
    <div v-if="campaignData && campaignData.dynamicLink && campaignData.locationValue === null">
      <a :href="campaignData.dynamicLink.shortLink" target="_blank">
        <img :src="campaignData.image" :alt="campaignData.dynamicLink.name" />
      </a>
    </div>

    <NoData v-if="isNoData"></NoData>

    <div class="pdt-16 pdl-16 pdr-16 pdb-20">
      <div
        class="header-card mdc-card mdc-elevation--z3 mgb-16 bg-white pda-default d-flex flex-row align-items-center justify-content-around t-center"
      >
        <div class="rank">
          <p
            class="t-body3 t-color-gray2 mgt-1 mgb-8"
            style="text-transform: uppercase;"
          >{{$t('785')}}</p>
          <p class="t-headline5 mgt-1 mgb-1 h-32 t-color-title">{{ mine.rank}}</p>
        </div>
        <div class="level mgx-auto">
          <span
            v-if="mine.profile"
            class="level-icon mgt-1 mgb-8 d-flex justify-content-center align-items-center bg-dark t-color-white font-m mgx-auto"
          >
            <img :src="mine.profile" alt />
          </span>
          <span
            v-else
            class="level-icon mgt-1 mgb-8 d-flex justify-content-center align-items-center t-color-white font-m mgx-auto"
          >
            <img src="/images/avatar_image.png" alt />
          </span>
          <div class="level-content d-flex align-items-baseline justify-content-center">
            <p
              class="t-helper t-color-gray2 mgt-1 mgb-1 pdr-4"
              style="text-transform: uppercase;"
            >{{$t('786')}}</p>
            <p class="t-subtitle3 mgt-1 mgb-1">{{ mine.levelName }}</p>
          </div>
        </div>
        <div class="rank">
          <p
            class="t-body3 t-color-gray2 mgt-1 mgb-8"
            style="text-transform: uppercase;"
          >{{$t('787')}}</p>
          <p class="t-headline5 mgt-1 mgb-1 h-32 t-color-title">{{ mine.point | commafy }}</p>
        </div>
      </div>
      <div class="mdc-card mdc-elevation--z3 bg-white">
        <div v-for="(leaderList, index) in listData" :key="index">
          <!-- 목록 캠페인 카드 -->

          <ListItem :leaderList="leaderList"></ListItem>
        </div>
      </div>
      <infinite-loading @infinite="fetchData" spinner="spiral">
        <div slot="no-more" class="mgt-16"></div>
        <div slot="no-results" class="mgt-16"></div>
      </infinite-loading>
    </div>
  </div>
</template>

<script>
/**
 * 나의 학습 목록 메인 컴포넌트(my learning main list component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import { MDCRipple } from "@material/ripple";
import memberApi from "@/api/memberApi.js";
import campaignApi from "@/api/campaignApi.js";
import ListItem from "./ListItem.vue";
import NoData from "../common/NoData.vue";
import InfiniteLoading from "vue-infinite-loading";

export default {
  components: {
    ListItem,
    NoData,
    InfiniteLoading,
  },

  data() {
    return {
      status: "",
      isNoData: false,
      campaignData: null,
      listData: [],
      currentPage: 1,
      totalPages: 1,
      mine: "",
    };
  },

  computed: {},
  filters: {
    commafy: function (value) {
      if (!value) return ''

      var str = value.toString();
      str = str.replace(/(\d)(?=(\d{3})+$)/g, '$1,');
      return str;
    }
  },
  watch: {
    $route(to, from) {
      this.initData();
    },
  },

  mounted() {
    // 기본 파라미터 설정(set default parameter)
    // if (!this.$route.query.status) {
    //     this.$router.push({query: {status: 'LEARNING'}})
    // }
  },

  methods: {
    initData() {
      this.listData = [];
      this.currentPage = 1;
      this.totalPages = 1;
    },
    // 목록 데이터 로딩(get list data)
    fetchData($state) {
      let responseData = null;
      let params = this.setParams();

      if (this.totalPages >= this.currentPage) {
        memberApi
          .leaderBoard()
          .then((response) => {
            responseData = response.data.data;
            this.mine = responseData.mine;
            //console.log('responseData=>',responseData);
            this.listData = this.listData.concat(responseData.rankings);
            this.currentPage++;
            this.totalPages = responseData.totalPages;

            if (responseData.rankings.length) {
              $state.loaded();
            } else {
              $state.complete();
            }

            console.log("nodata", this.listData.length);
            if (this.listData.length > 0) {
              this.isNoData = false;
            } else {
              this.isNoData = true;
            }
          })
          .catch((err) => {
            $state.error();
          });
      } else {
        $state.complete();
      }

      // 캠페인 테이터 API 호출(get campaign data)
      let locationType =
        this.$route.query.status === "LEARNING"
          ? "LEARN_IN_PROGRESS_DEGREE"
          : "LEARN_COMPLETED_DEGREE";
      campaignApi
        .campaign({ locationType: locationType })
        .then((response) => {
          console.info(`I am campagion data`, response.data.data);
          this.campaignData = response.data.data;
        })
        .catch((err) => {});
    },

    // 파라미터 설정(set parameter)
    setParams() {
      const params = {
        status: this.$route.query.status,
        name: "",
        category: "",
        page: this.currentPage,
        size: 10,
      };
      return params;
    },

    // 학습진행률 노출 상태 설정(set/toggle learning status graph)
    initProgressStatus(id) {
      _.map(this.listData, (o) => {
        o.id === id && o.progressViewStatus === false
          ? (o.progressViewStatus = true)
          : (o.progressViewStatus = false);
      });
    },
  },
};
</script>

<style scoped>
.bg-red3 {
  background: #2d6dcc;
}
.t-color-textField2 {
  color: #acb4be;
}
.t-color-textField1 {
  color: #546e7a;
}
.bg-textField2 {
  background-color: #acb4be;
}
.nav-extended .brand-logo,
.nav-content * {
  font-family: noto-regular;
}
.nav-extended .brand-logo {
  font-size: 20px;
}
.tabs .tab a:focus,
.tabs .tab a:focus.active {
  background-color: #f5f5f5;
  outline: none;
}
.tabs .indicator {
  background: #2d6dcc;
}
.tabs .tab {
  width: 50%;
}
.mdc-elevation--z3 {
  border-radius: 4px;
  overflow: hidden;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.26);
  background-color: #ffffff;
}
.header-card {
  height: 120px !important;
}
.listItems {
  border-bottom: 1px solid #e6eced;
}

.rank {
  min-width: 82px;
}
.ranktab2 {
  min-width: 46px;
}

.level-icon {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  font-size: 28px;
  overflow: hidden;
}

.slIcon {
  width: 35px;
}
.slIcon img {
  width: 27px;
}
.userListIcon {
  width: 40px;
  min-width: 40px;
  height: 40px;
  border-radius: 50%;
}
.userListIcon img {
  width: 40px;
}

.listContent p:first-child {
  font-size: 16px;
}
.listPointIcon {
  width: 19px;
  min-width: 19px;
  height: 19px;

  border-radius: 50%;
}
.levelHeading .listPointIcon {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  font-weight: 500;
}

@media (max-width: 480px) {
  .listContent {
    margin-right: auto;
  }
}
</style>